import { render, staticRenderFns } from "./CheckboxForm.vue?vue&type=template&id=e620cde0&"
import script from "./CheckboxForm.vue?vue&type=script&lang=js&"
export * from "./CheckboxForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports